export default __webpack_public_path__ + "static/media/logo-blanco.859631fb.svg";